/** The id of the compare table on the plans page: "+ N more in the table" scrolls to it. */
export const PLANS_COMPARE_ID = 'plans-compare';

/** Scrolls the plans page to the compare table. */
export function scrollToPlansCompare(): void {
  document.getElementById(PLANS_COMPARE_ID)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
